import {observer} from "mobx-react-lite";
import {RankingOverview} from "../components/RankingOverview";
import {StateService} from "../services/StateService";
import {makeStyles} from "@material-ui/core/styles";
import {autorun} from "mobx";
import {useEffect, useState} from "react";
import {RoundEntry} from "../stores/RoundStore";
import {BasicHeroSection} from "../components/BasicHeroSection";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
    minHeight: "100vh",
    paddingTop: "65px",
    maxWidth: "1400px",
    margin: "0 auto",
  },
  countDownTime: {
    width: "98%",
    margin: "0 auto",
    marginTop: "20px",
    paddingBottom: "15px",
  },
  countDown: {
    width: "100%",
    color: "white",
    borderRadius: "10px",
    position: 'relative',
  },
  leftLayout: {
    position: 'absolute',
    width: '527px',
    height: '391px',
    transform: 'translate(-9%, -48%)',
    left: '0',
    top: '0',
    background: 'linear-gradient(199.55deg, rgba(72, 46, 95, 0.225033) 40.83%, #503045 105.46%)',
    mixBlendMode: 'normal',
    opacity: '0.9',
    filter: 'blur(135.914px)',
  },
  rightLayout: {
    position: 'absolute',
    width: '433px',
    height: '461px',
    right: '0px',
    top: '74px',
    background: 'linear-gradient(190.81deg, #503045 40.52%, rgba(72, 46, 95, 0.225033) 86.44%)',
    mixBlendMode: 'normal',
    opacity: 0.9,
    filter: 'blur(135.914px)',
    transform: 'rotate(83deg)',
  },
  innerLay: {
    background: '#6E37FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
  innerLay1: {
    background: '#3772FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
}));

interface VotePageProps {
  state: StateService;
}

export const VotePage = observer((props: VotePageProps) => {
  const classes = useStyles();

  const [activeRound, setActiveRound] = useState<RoundEntry | null>(null);

  useEffect(() => {
    let disposer = autorun(reaction => {
      const round = props.state.rounds.getActiveVoteRoundOrLatest();
      if (activeRound === null && round !== undefined) {
        setActiveRound(round);
        reaction.dispose();
      }
    });
    return () => {
      disposer();
    };
  }, [props.state.rounds, props.state.authentication, activeRound]);

  let countDownDate: Date | undefined;
  if (props.state.rounds.isVotePhase()) {
    const endTime = props.state.rounds.getActiveVoteRoundOrLatest()?.end_time
    if (endTime) {
      countDownDate = new Date(endTime)
    }
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.countDown}>
        <div className={classes.leftLayout}></div>
          <div className={classes.rightLayout}>
            <div className={classes.innerLay}>
            </div>
            <div className={classes.innerLay1}>
            </div>
          </div>
          <div className={classes.countDownTime}>
            <BasicHeroSection
              title="VOTE CLOSES IN"
              state={props.state}
              countDownDate={countDownDate}
            />
          </div>
        </div>
        <div className="ranking-page">
          <RankingOverview state={props.state} />
        </div>
      </div>
    </>
  );
});
